<template>
  <div>
    <div v-if="state == 'approve'">
      <b-card body-="p-4" header-class="border-0">
        <h2>
          Appoinment for {{ customer.firstName }} {{ customer.lastName }} on
          {{ dt | moment("dddd,  MMMM Do YYYY") }}
        </h2>
        <a href="#" @click.prevent="state = 'appt'" v-if="state == 'approve'"
          >Change Appointment
        </a>
      </b-card>

      <ConfirmAppt
        class="mt-4"
        :appts="appts"
        :customer="customer"
        v-if="appts && customer && state == 'approve'"
        @action="action"
      />
    </div>

    <b-card body-="p-4" header-class="border-0" v-show="state == 'appt'">
      <div class="wrapper">
        <div>
          <Procedures
            :procedures="procedures"
            @updated="proceduresUpdated"
            v-if="procedures"
          />
        </div>
        <div style="border-left:  solid  1px #efefef"></div>
        <div>
          <Schedule
            @apptsUpdated="apptsUpdated"
            :selectedProcedures="selectedProcedures"
            v-if="selectedProcedures.length > 0"
          />
        </div>
      </div>

      <div v-if="appts.length > 0">
        <div class="mt-4">
          <b-button variant="primary" block @click="state = 'approve'"
            >Confirm Appointment</b-button
          >
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import Procedures from "./Procedures.vue";
import TimeOfDay from "./TimeOfDay.vue";
import Schedule from "./Schedule.vue";
import ConfirmAppt from "./ConfirmAppt.vue";

import { preventSelection } from "@fullcalendar/core";
export default {
  name: "Calendar",
  components: { Procedures, TimeOfDay, Schedule, ConfirmAppt },
  props: { customer: null },
  computed: {
    dt() {
      if (this.appts.length > 0) return this.appts[0].startDate;
      else return null;
    },
  },
  data() {
    return {
      selectedProcedures: [],
      procedures: null,
      appts: [],
      state: "appt",
      act: null,
    };
  },

  async created() {
    await this.bindSelections();
  },
  methods: {
    action(a) {
      this.act = a;
      this.$emit("newApptSelected", this.buildAddApptRequest());
    },
    apptsUpdated(appts) {
      this.appts = appts;
    },

    proceduresUpdated(procedures) {
      this.selectedProcedures = procedures;
    },
    async bindSelections() {
      let r = await this.$client.get("/api/appt/getSelections");

      if (r.data.isSuccess) {
        this.procedures = r.data.value.procedures;
      }
    },
  },
};
</script>
<style scoped>
.wrapper {
  display: grid;

  grid-template-columns: 250px 1px 1fr;

  gap: 50px;
}
</style>
